import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/operated/weightPV',
    owner: '/home',
    authority: 'entityPVWeight',
    component: Loadable({
      loader: () => import('./index'),
      loading: () => <RouteLoading />
    })
  },
];